<template>
  <div
    id="form-search-popover"
    class="component-card container-app-search">
    <j-title-header :options="title"/>

    <b-row>
      <b-col md="4">
        <b-form-group :class="{'error-input' : $v.konseling.tahun_ajaran.$error}">
          <label> Tahun Ajaran </label>
          <j-single-select
            v-model="$v.konseling.tahun_ajaran.$model"
            :options="list_tahun_ajaran"
            :placeholder="'Select Tahun Ajaran'"
            value-format="object"
            label="tahunajaran"
            @getData="getDataKelas"/>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group :class="{'error-input' : $v.konseling.semester.$error}">
          <label> Semester </label>
          <j-single-select
            v-model="$v.konseling.semester.$model"
            :options="list_semester"
            :placeholder="'Pilih Semester'"
            :disabled="!konseling.tahun_ajaran"
            value-format="object"
            label="name"/>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group :class="{'error-input' : $v.konseling.kelas.$error}">
          <label> Kelas </label>
          <j-single-select
            v-model="$v.konseling.kelas.$model"
            :options="list_kelas"
            :placeholder="'Select Kelas'"
            :disabled="!konseling.semester"
            value-format="object"
            label="name"/>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="float-to-right m__t--20 m__b--20">
          <b-button
            :disabled="!konseling.tahun_ajaran || !konseling.semester || !konseling.kelas"
            class="btn blue"
            @click="cariData">
            Cari
          </b-button>
        </div>
      </b-col>
    </b-row>

    <v-server-table
      v-if="show_table"
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="openCreateModal">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>
    </v-server-table>
    <jLoadingTable v-if="show_table && !load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_konseling.nis.$error}">
            <label> Siswa </label>
            <j-single-select
              v-model="$v.data_konseling.nis.$model"
              :options="list_siswa"
              :placeholder="'Pilih Siswa'"
              value-format="object"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_konseling.title.$error}">
            <label> Title </label>
            <j-input
              v-model="$v.data_konseling.title.$model"
              placeholder="Title"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_konseling.attachment.$error}">
            <label> File </label>
            <j-upload-file
              v-model="$v.data_konseling.attachment.$model"
              :accepted-file-type="['xls', 'xlsx', 'docx', 'doc', 'pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_konseling.attachment.$model"
              :url-upload="url_upload"
              @url="getUrl"/>
              <!-- <j-singleupload
              v-model="$v.data_konseling.attachment.$model"
              :accepted-file-type="['xls', 'xlsx', 'docx', 'doc', 'pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_konseling.attachment.$model"
              :url-upload="url_upload"
              @url="getUrl"/>
            <label>
              Please choose file with supported format file
              xls, xlsx, docx, doc, pdf, jpg, png, jpeg.
            </label> -->
          </b-form-group>

          <j-form-base
            v-if="showAdditionalInfo"
            ref="jFormCreate"
            :data-fields="dataFields"/>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_konseling.nis.$error}">
            <label> Siswa </label>
            <j-single-select
              v-model="$v.data_konseling.nis.$model"
              :options="list_siswa"
              :placeholder="'Pilih Siswa'"
              :disabled="readOnly"
              value-format="object"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_konseling.title.$error}">
            <label> Title </label>
            <j-input
              v-model="$v.data_konseling.title.$model"
              :disabled="readOnly"
              placeholder="Title"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_konseling.attachment.$error}">
            <label> File </label>
            <j-upload-file
              v-if="showAdditionalInfo"
              v-model="$v.data_konseling.attachment.$model"
              :accepted-file-type="['xls', 'xlsx', 'docx', 'doc', 'pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_konseling.attachment.$model"
              :name-default="fileNameDefault"
              :url-upload="url_upload"
              :disabled="readOnly"
              @url="getUrl"/>
              <!-- <j-singleupload
              v-model="$v.data_konseling.attachment.$model"
              :accepted-file-type="['xls', 'xlsx', 'docx', 'doc', 'pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_konseling.attachment.$model"
              :url-upload="url_upload"
              @url="getUrl"/>
            <label>
              Please choose file with supported format file
              xls, xlsx, docx, doc, pdf, jpg, png, jpeg.
            </label> -->
          </b-form-group>

          <j-form-base
            v-if="showAdditionalInfo"
            ref="jFormUpdate"
            :data-fields="dataFields"
            :is-detail="true"
            :is-disabled="readOnly"/>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="9">
          <div class="float-to-right m__t--20">
            <!-- <b-button
              class="btn green m__r--5"
              @click="submitData">
              Submit
            </b-button> -->
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKesiswaan from '@/services/jApiKesiswaan';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jFormBase from '@/views/kurikulum/additional-info/jFormBase';
import jUploadFile from '@/components/upload-file/jUploadFile';

export default {
  components: {
    jLoadingTable,
    jFormBase,
    jUploadFile,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Data Konseling',
      },

      list_tahun_ajaran: [],
      list_konseling: [],
      list_kelas: [],
      list_siswa: [],
      list_semester: [
        { id: 'ganjil', name: 'Ganjil' },
        { id: 'genap', name: 'Genap' },
      ],

      konseling: {
        tahun_ajaran: null,
        semester: null,
        kelas: null,
      },
      data_konseling: {
        nis: null,
        type: null,
        title: '',
        semester: null,
        category_id: '12',
        attachment: null,
        additional_info: [],
        tahunajaran: null,
        kode_kelas: null,
        kode_ekskul: null,
      },
      list_type: [
        { id: 'Konseling', name: 'Konseling' },
      ],
      token: (JSON.parse(localStorage.getItem('Token'))).value,
      dataFields: [],
      fileNameDefault: '',
      showAdditionalInfo: false,
      load_first: false,
      show_table: false,
      data_table: [],
      selected_rows: [],
      columns: ['id', 'title'],
      options: {
        headings: {
          id: 'ID',
          title: 'TITLE',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            status: 'draft',
            module_id: 7,
            category_id: 12,
            tahunajaran: data.tahunajaran ? data.tahunajaran : '',
            semester: data.semester ? data.semester : '',
            kode_kelas: data.kode_kelas ? data.kode_kelas : '',
            limit: data.limit,
            page: data.page,
          };
        },
        requestFunction(data) {
          const getList = jApiKesiswaan.getListDocument(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
    url_upload() {
      return `${process.env.GATE_URL}file/upload`;
    },
  },
  watch: {
  },
  created() {
    this.listTahunAjaran();
    this.getDataAdditionalInfo();
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKesiswaan', [
      'getAdditionalInfo', 'createDocument', 'updateDocument', 'detailDocument', 'deleteDocument', 'submitDocument',
      'getListTahunAjaran', 'getListKelas', 'getListSiswaByKelas',
    ]),

    listTahunAjaran() {
      const paramTahunAjaran = {
        pagination: {
          query: '',
          query_type: '',
        },
      };
      this.getListTahunAjaran(paramTahunAjaran).then((res) => {
        this.list_tahun_ajaran = res.data.data;
      });
    },

    getDataAdditionalInfo() {
      this.getAdditionalInfo(12).then((res) => {
        this.dataFields = res.data.data.map(el => ({
          id: el.id,
          name: el.field_name,
          type: el.type,
          placeholder: el.placeholder,
          field_key: el.field_key,
          is_delete: false,
          is_editable: false,
          is_mandatory: false,
        }));
      });
    },

    getDataKelas() {
      const params = {
        pagination: {
          query: this.konseling.tahun_ajaran.tahunajaran,
          query_type: 'tahunajaran',
        },
      };
      this.getListKelas(params).then((res) => {
        this.list_kelas = res.data.data;
        this.konseling.kelas = null;
      });
    },

    cariData() {
      this.show_table = true;
      if (this.load_first) {
        this.$refs.tableServer.getData();
      }
      const params = {
        kode_kelas: this.konseling.kelas.kode,
        tahunajaran: this.konseling.tahun_ajaran.tahunajaran,
      };
      this.getListSiswaByKelas(params).then((res) => {
        this.list_siswa = res.data.data;
      });
    },

    getUrl(data) {
      this.data_konseling.attachment = data;
    },

    loading(val) {
      const a = val;
      a.tahunajaran = this.konseling.tahun_ajaran.tahunajaran;
      a.semester = this.konseling.semester.id;
      a.kode_kelas = this.konseling.kelas.kode;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    openCreateModal() {
      this.$refs.modalCreate.show();
      this.showAdditionalInfo = true;
      this.data_konseling = {
        nis: null,
        type: 'Konseling',
        title: '',
        semester: this.konseling.semester.id,
        category_id: '12',
        attachment: null,
        additional_info: [],
        tahunajaran: this.konseling.tahun_ajaran.tahunajaran,
        kode_kelas: this.konseling.kelas.kode,
        kode_ekskul: null,
      };
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.showAdditionalInfo = false;
      this.data_konseling = {
        nis: null,
        type: null,
        title: '',
        semester: null,
        category_id: '12',
        attachment: null,
        additional_info: [],
        tahunajaran: null,
        kode_kelas: null,
        kode_ekskul: null,
      };
      setTimeout(() => {
        this.$v.data_konseling.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.showAdditionalInfo = false;
      this.data_konseling = {
        nis: null,
        type: null,
        title: '',
        semester: null,
        category_id: '12',
        attachment: null,
        additional_info: [],
        tahunajaran: null,
        kode_kelas: null,
        kode_ekskul: null,
      };
      setTimeout(() => {
        this.$v.data_konseling.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();

      const params = {
        id: param.row.id,
      };
      this.detailDocument(params).then((res) => {
        const nisSelected = this.list_siswa.find(f => f.nis === param.row.nis);
        this.data_konseling = {
          id: param.row.id,
          nis: nisSelected || null,
          type: 'Konseling',
          semester: param.row.semester,
          title: param.row.title,
          category_id: '12',
          attachment: param.row.attachment,
          additional_info: [],
          tahunajaran: this.konseling.tahun_ajaran.tahunajaran,
          kode_kelas: this.konseling.kelas.kode,
          kode_ekskul: null,
        };
        this.dataFields = res.data.data.additional_info.map(el => ({
          id: el.id,
          name: el.field_name,
          type: el.type,
          placeholder: el.placeholder,
          field_key: el.field_key,
          value: el.value,
          is_delete: false,
          is_editable: false,
          is_mandatory: false,
        }));
        this.fileNameDefault = res.data.data.attachment_name || '-';
        this.showAdditionalInfo = true;
      });
    },

    saveData() {
      this.$v.data_konseling.$touch();
      if (!this.$v.data_konseling.$error) {
        this.$refs.jFormCreate.getData().then((params) => {
          this.data_konseling.nis = this.data_konseling.nis ? this.data_konseling.nis.nis : '';
          this.data_konseling.additional_info = params.map(e => ({
            field_key: e.field_key,
            value: e.value,
          }));
          this.createDocument(this.data_konseling).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalCreate();
              }, 1500);
            }
          });
        });
      }
    },

    updateData() {
      this.$v.data_konseling.$touch();
      if (!this.$v.data_konseling.$error) {
        this.$refs.jFormUpdate.getData().then((params) => {
          this.data_konseling.nis = this.data_konseling.nis ? this.data_konseling.nis.nis : '';
          this.data_konseling.additional_info = params.map(e => ({
            field_key: e.field_key,
            value: e.value,
          }));
          this.updateDocument(this.data_konseling).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_konseling.id,
          };
          this.deleteDocument(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },

    submitData() {
      this.$swal({
        title: 'Submit Data',
        text: 'Are you sure want to submit this data?',
        showCancelButton: true,
        confirmButtonText: 'Submit',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_konseling.id,
          };
          this.submitDocument(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      konseling: {
        tahun_ajaran: { required },
        kelas: { required },
        semester: { required },
      },
      data_konseling: {
        nis: { required },
        title: { required },
        attachment: { },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/bimbingan-konseling/konseling/jKonselingList.vue